module.exports = __webpack_public_path__ + "img/office.eb22a9cf.png";